import React, { useState } from "react";
import PropTypes from "prop-types";
import SignUpStep1 from "./step-1/SignUpStep1";
import SignUpStep2 from "./step-2/SignUpStep2";

function SignUpForm({ client, location, onComplete, fullWidth }) {
  const [progress, setProgress] = useState(1);

  const callback = newStep => {
    window.scrollTo(0, 0);
    setProgress(newStep);
  };

  return (
    <>
      <div className="progress-counter">
        <span
          className={`progress-counter__dot${
            progress >= 1 ? " progress-counter__dot--active" : ""
          }`}
        />
        <span
          className={`progress-counter__dot${
            progress >= 2 ? " progress-counter__dot--active" : ""
          }`}
        />
      </div>
      {progress === 1 ? (
        <SignUpStep1
          client={client}
          location={location}
          callback={callback}
          nextStep={2}
          fullWidth={fullWidth}
        />
      ) : (
        <></>
      )}

      {progress === 2 ? (
        <SignUpStep2
          marketingOptIn={false}
          onComplete={onComplete}
          fullWidth={fullWidth}
        />
      ) : (
        <></>
      )}
    </>
  );
}

SignUpForm.propTypes = {
  client: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  onComplete: PropTypes.func,
  fullWidth: PropTypes.bool
};

SignUpForm.defaultProps = {
  onComplete: undefined,
  fullWidth: false
};

export default SignUpForm;
